import CaseStudyContainer from "./containers/CaseStudyContainer";
export default CaseStudyContainer;
